var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "bg-white", attrs: { flat: _vm.page_news } },
    [
      !_vm.page_news
        ? _c(
            "q-card-title",
            { staticClass: "text-center bg-primary text-white" },
            [_vm._v("\n        " + _vm._s(_vm.$t(_vm.title_news)) + "\n    ")]
          )
        : _vm._e(),
      !_vm.page_news ? _c("q-card-separator") : _vm._e(),
      _c(
        "q-card-main",
        {
          staticClass: "text-center relative-position",
          style: _vm.home ? "" : "min-height: 50vh"
        },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "", separator: "", link: "" } },
            [
              _vm._l(_vm.filteredNews, function(item, index) {
                return _c(
                  "q-item",
                  {
                    key: index,
                    staticClass: "q-py-lg",
                    nativeOn: {
                      click: function($event) {
                        return _vm.openNews(item)
                      }
                    }
                  },
                  [
                    _c(
                      "q-item-side",
                      [
                        _c("q-icon", {
                          attrs: { name: "far fa-newspaper", size: "2rem" }
                        })
                      ],
                      1
                    ),
                    _c("q-item-main", {
                      attrs: { label: item.title, sublabel: _vm.getDate(item) }
                    })
                  ],
                  1
                )
              }),
              _vm.news.length === 0 && _vm.news_loaded
                ? _c(
                    "q-item",
                    { staticClass: "q-py-lg" },
                    [
                      _c(
                        "q-item-side",
                        [
                          _c("q-icon", {
                            attrs: { name: "far fa-newspaper", size: "2rem" }
                          })
                        ],
                        1
                      ),
                      _c("q-item-main", {
                        attrs: { label: _vm.$t("no_news_found") }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _c(
            "q-inner-loading",
            { attrs: { visible: !_vm.news_loaded } },
            [_c("q-spinner-dots", { attrs: { size: 60, color: "secondary" } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }